export default __webpack_public_path__ + "static/media/thunderStorm.3234deaf.jpg";